import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { Discount } from '@nucleus-commerce/api-client/admin';
import { useFormat } from '@nucleus-commerce/i18n/react';

/** "10% off", "$50.00 off" or "Free shipping". */
export function useDiscountValue() {
  const { t } = useTranslation('discounts');
  const format = useFormat();
  return useCallback(
    (discount: Pick<Discount, 'method' | 'percentage' | 'amount'>): string => {
      if (discount.method === 'percentage' && discount.percentage !== null) {
        return t('value.percentage', { value: format.number(discount.percentage) });
      }
      if (discount.method === 'fixed_amount' && discount.amount) {
        return t('value.fixedAmount', { value: format.money(discount.amount) });
      }
      return t('value.freeShipping');
    },
    [format, t],
  );
}
